const MONTH_ABBREVIATIONS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) {
    return '';
  }
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) {
    return '';
  }
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTH_ABBREVIATIONS[d.getMonth()];
  const year = d.getFullYear();
  return `${day} ${month} ${year}`;
};
